export default {
	国家: '国家',
	前缀: '前缀',
}
